module.exports = __webpack_public_path__ + "img/EMC_H_2.5ab95233.png";